import SocialList from './social-list';
import ToolsList from './tools-list';

const Footer = ({ links, url, year, sendClickEmail, sendClickMenuTools }) => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__content">
          <div className="footer__content-column">
            <div className="tools">
              <h3>Tools</h3>
              <ul className="tools__list">
                <ToolsList
                  links={links}
                  url={url}
                  sendClickMenuTools={sendClickMenuTools}
                />
              </ul>
            </div>
          </div>
          <div className="footer__content-column">
            <div className="follow">
              <h3>Follow us</h3>
                <SocialList />
            </div>
            <div className="contacts">
              <h3>Contact us</h3>
              <p>
                Need support or have a suggestion?
                <br />
                We want to make friends with our clients, so we will be happy
                <br />
                to answer your questions.
              </p>
              <a
                onClick={() => sendClickEmail()}
                href="mailto:emma.cooper@retoucher.online"
              >
                <i className="icon__mail" />
                emma.cooper@retoucher.online
              </a>
            </div>

            <a href="/privacy-policy">Privacy policy</a>
          </div>
        </div>

        <hr />
        <p className="footer__copyright">
          © {year} Retoucher online. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
